<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog" class="cursor-pointer">mdi-close</v-icon>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="validForm" lazy-validation>
          <!-- Información Básica -->
          <v-row>
            <v-col cols="12">
              <div class="subtitle-2 font-weight-bold mb-3">Información Básica</div>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.name"
                label="Nombre Completo"
                outlined
                dense
                :rules="[v => !!v || 'Nombre es requerido']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="form.status"
                :items="[
                  { text: 'Activo', value: 'activo' },
                  { text: 'Inactivo', value: 'inactivo' }
                ]"
                label="Estado"
                outlined
                dense
                :rules="[v => !!v || 'Estado es requerido']"
              ></v-select>
            </v-col>
          </v-row>

          <!-- Contacto -->
          <v-row>
            <v-col cols="12">
              <div class="subtitle-2 font-weight-bold mb-3">Contacto</div>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.email"
                label="Email"
                type="email"
                outlined
                dense
                :rules="[v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Email inválido']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.phone"
                label="Teléfono"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Disponibilidad -->
          <v-row>
            <v-col cols="12">
              <div class="subtitle-2 font-weight-bold mb-2">Disponibilidad Horaria</div>
              <v-textarea
                v-model="form.availability"
                label="Descripción de disponibilidad (ej: Lunes, Miércoles, Viernes 9:00 AM - 2:00 PM)"
                outlined
                dense
                rows="2"
                counter
                maxlength="200"
              ></v-textarea>
            </v-col>
          </v-row>

          <!-- Especialidades -->
          <v-row>
            <v-col cols="12">
              <div class="subtitle-2 font-weight-bold mb-2">Especialidades</div>
              <v-chip-group v-model="form.specialties" multiple>
                <v-chip
                  v-for="spec in specialtyOptions"
                  :key="spec"
                  filter
                  outlined
                >
                  {{ spec }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

          <!-- Certificación -->
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.certification"
                label="Certificación/Credencial"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Cancelar</v-btn>
        <v-btn color="primary" text @click="submitForm" :disabled="!validForm">
          {{ formTitle === 'Nuevo Profesor' ? 'Agregar' : 'Actualizar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TeacherDialog',
  props: {
    dialog: Boolean,
    teacher: Object
  },
  data () {
    return {
      validForm: false,
      specialtyOptions: ['Swing', 'Putting', 'Pitch', 'Chip', 'Full Swing', 'Short Game', 'Técnica Básica'],
      form: {
        name: '',
        email: '',
        phone: '',
        status: 'activo',
        availability: '',
        specialties: [],
        certification: ''
      }
    }
  },
  computed: {
    formTitle () {
      return this.teacher && this.teacher.id ? 'Editar Profesor' : 'Nuevo Profesor'
    }
  },
  watch: {
    dialog (newVal) {
      if (newVal) {
        if (this.teacher && this.teacher.id) {
          this.form = { ...this.teacher }
        } else {
          this.resetForm()
        }
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('update:dialog', false)
    },
    submitForm () {
      if (this.$refs.form.validate()) {
        this.$emit('save', { ...this.form })
        this.resetForm()
      }
    },
    resetForm () {
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.form = {
        name: '',
        email: '',
        phone: '',
        status: 'activo',
        availability: '',
        specialties: [],
        certification: ''
      }
      this.validForm = false
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
